import React, { useState } from "react";
import { Button } from "@mui/material";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { StoreItem } from "../../../../../../../domain/models/storage-item";
import { Total } from "../../../../Components/Total";
import CircularProgress from "@mui/material/CircularProgress";
import { useSelector } from "react-redux";
import { checkShipmentActions, checkShipmentState } from "../../store";
import DrawerAppBar from "../../../../../../components/mobile/Navbar";
import { useNavigate } from "react-router-dom";
import {
  CheckCargos,
  ItemCount,
} from "../../../../../../../domain/usecases/check-cargos";
import { useDispatch } from "react-redux";
import { useErrorHandler } from "../../../../../hooks";
import { CheckCargoById } from "../../../../../../../domain/usecases/check-cargo-by-id";

type Props = {
  checkCargos: CheckCargoById;
};

export const CheckShipmentByCargoList: React.FC<Props> = ({ checkCargos }) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleError = useErrorHandler((error) => {
    alert(error);
  });

  const list = useSelector<checkShipmentState, StoreItem[]>(
    (state) => state.checkList
  );
  const cargoId = useSelector<checkShipmentState, number>(
    (state) => state.cargoId as number
  );

  async function check() {
    try {
      setIsLoading(true);
      const res = await checkCargos.check({
        id: cargoId,
        count: list.map((item) => ({
          ...item,
          amount: Number((item.amount * (item?.packageAmount || 1)).toFixed(2)),
        })) as ItemCount,
      });
      if (res.status === "completed") {
        alert("Cargas conferidas com sucesso");
        dispatch(checkShipmentActions.setCheckList({ list: [] }));
        return navigate("/mobile/tasks");
      }
      navigate("/mobile/check/shipments/report", {
        state: { checkResult: res },
      });
    } catch (error) {
      handleError(error as Error);
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <>
      <DrawerAppBar
        title="Lista de Conferência"
        onBack={() => {
          navigate(-1);
        }}
      />
      <Total text="Total de Itens Conferidos" number={`${list.length}`} />
      <Stack sx={{ m: "20px" }} spacing={4}>
        {list.map((item, index) => {
          return (
            <Paper sx={{ padding: "20px" }} key={index}>
              <Stack spacing={2}>
                <Typography fontWeight="bold" fontSize="24px">
                  {item.description}
                </Typography>
                <Typography>{`Fornecedor: ${item.supplier}`}</Typography>
                {item.batchControl && (
                  <Typography>{`Lote: ${item.batch}`}</Typography>
                )}
                <Typography>{`Quantidade: ${item.amount}`}</Typography>
              </Stack>
            </Paper>
          );
        })}

        <Button
          variant="contained"
          color="secondary"
          sx={{ color: "white", height: "50px", fontWeight: "bold" }}
          onClick={check}
        >
          {isLoading ? <CircularProgress /> : "Finalizar Conferência"}
        </Button>
      </Stack>
    </>
  );
};
